import { RouteConfig } from 'vue-router';
import { Notification } from 'element-ui';
import { ResourceCreate } from '@/components';
import store from '@/store';
import { Permissions } from '@/types';

const UserEdit = () =>
  import(/* webpackChunkName: "user-routes" */ '@/components/Users/UserEdit.vue');
const Team = () =>
  import(/* webpackChunkName: "user-routes" */ '@/components/Users/Team.vue');
const Invite = () =>
  import(/* webpackChunkName: "user-routes" */ '@/components/Users/Invite.vue');

const routes: RouteConfig[] = [
  {
    path: 'users',
    alias: 'team',
    name: 'users',
    components: {
      default: Team,
      pageActions: ResourceCreate
    },
    props: {
      pageActions: {
        text: 'Invite Members',
        route: 'users/invite'
      }
    },
    meta: {
      pageTitle: 'Team',
      permission: Permissions.QUERY_USERS
    }
  },
  {
    path: 'users/invite',
    name: 'users-invite',
    components: {
      default: Invite
    },
    meta: {
      pageTitle: 'Invite new member',
      showBackButton: true,
      permission: Permissions.INVITE_USER
    }
    // beforeEnter: (to, from, next) => {
    //   if (store.getters.isSuperAdmin) {
    //     next();
    //   } else {
    //     Notification.error('Only SuperAdmin can invite team member.');
    //   }
    // }
  },
  {
    path: 'users/:id(\\d+)/edit',
    name: 'users-edit',
    components: {
      default: UserEdit
    },
    props: {
      default: true
    },
    meta: {
      pageTitle: 'Profile Update',
      showBackButton: true,
      permission: Permissions.UPDATE_USER
    }
  }
];

export default routes;
